const ArchiveMusicVideos2021Static = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/a5TkVrfFQP8" title="spine" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            spine (prod. jodom)
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/nkQdMsfp0y8" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            AMEN
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/DtIhFQSMGVg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            ZERO
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/ka715cKjppo" title="spine" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>panda slugger & Kawaii Ry</strong><br/>
            Whole World Froze (prod. panda slugger)
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/agFi-Bglf60" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            CHELSEY
          </p>

        </div>
      </>
    );
  };
  export default ArchiveMusicVideos2021Static;